import {combineOnKey, reducer} from './helpers'
import {
  CLEAR_PARTICIPANT_INFO,
  CREATE_EVENT_LOOK_FAILURE,
  CREATE_EVENT_LOOK_PENDING,
  CREATE_EVENT_LOOK_SUCCESS,
  GET_CHECKOUT_MESSAGE_FAILURE,
  GET_CHECKOUT_MESSAGE_PENDING,
  GET_CHECKOUT_MESSAGE_SUCCESS,
  GET_EVENT_LOOKS_FAILURE,
  GET_EVENT_LOOKS_PENDING,
  GET_EVENT_LOOKS_SUCCESS,
  GET_PARTICIPANT_INFO_FAILURE,
  GET_PARTICIPANT_INFO_PENDING,
  GET_PARTICIPANT_INFO_SUCCESS,
  GET_SOONEST_EVENT_DATE_FAILURE,
  GET_SOONEST_EVENT_DATE_PENDING,
  GET_SOONEST_EVENT_DATE_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_PENDING,
  LOGIN_SUCCESS,
  REGISTRATION_FAILURE,
  REGISTRATION_PENDING,
  REGISTRATION_SUCCESS,
  PASSWORD_RESET_REQUEST_FAILURE,
  PASSWORD_RESET_REQUEST_PENDING,
  PASSWORD_RESET_REQUEST_SUCCESS,
} from '../actions/api'

import {
  GET_PARTICIPANT_LOOK_FAILURE,
  GET_PARTICIPANT_LOOK_PENDING,
  GET_PARTICIPANT_LOOK_SUCCESS,
} from '../actions/looks'

export default reducer({}, (state, {payload, type}) => {
  switch (type) {
    case CLEAR_PARTICIPANT_INFO:
      return combineOnKey('participant', state, {
        data: null,
        error: null,
        status: null,
      })
    case CREATE_EVENT_LOOK_FAILURE:
      return combineOnKey('newEventLook', state, {
        data: null,
        error: payload,
        status: 'FAILURE',
      })
    case CREATE_EVENT_LOOK_PENDING:
      return combineOnKey('newEventLook', state, {
        status: 'PENDING',
      })
    case CREATE_EVENT_LOOK_SUCCESS:
      return combineOnKey('newEventLook', state, {
        data: payload,
        error: null,
        status: 'SUCCESS',
      })
    case GET_CHECKOUT_MESSAGE_FAILURE:
      return combineOnKey('bannerMessage', state, {
        data: null,
        error: payload,
        status: 'FAILURE',
      })
    case GET_CHECKOUT_MESSAGE_PENDING:
      return combineOnKey('bannerMessage', state, {
        status: 'PENDING',
      })
    case GET_CHECKOUT_MESSAGE_SUCCESS:
      return combineOnKey('bannerMessage', state, {
        data: payload,
        error: null,
        status: 'SUCCESS',
      })
    case GET_EVENT_LOOKS_FAILURE:
      return combineOnKey('looks', state, {
        status: 'FAILURE',
      })
    case GET_EVENT_LOOKS_PENDING:
      return combineOnKey('looks', state, {
        status: 'PENDING',
      })
    case GET_EVENT_LOOKS_SUCCESS:
      return combineOnKey('looks', state, {
        status: 'SUCCESS',
      })
    case GET_PARTICIPANT_LOOK_FAILURE:
      return combineOnKey('looks', state, {
        status: 'FAILURE',
      })
    case GET_PARTICIPANT_LOOK_PENDING:
      return combineOnKey('looks', state, {
        status: 'PENDING',
      })
    case GET_PARTICIPANT_LOOK_SUCCESS:
      return combineOnKey('looks', state, {
        status: 'SUCCESS',
      })
    case GET_PARTICIPANT_INFO_FAILURE:
      return combineOnKey('participant', state, {
        data: null,
        error: payload,
        status: 'FAILURE',
      })
    case GET_PARTICIPANT_INFO_PENDING:
      return combineOnKey('participant', state, {
        status: 'PENDING',
      })
    case GET_PARTICIPANT_INFO_SUCCESS:
      return combineOnKey('participant', state, {
        data: payload,
        error: null,
        status: 'SUCCESS',
      })
    case GET_SOONEST_EVENT_DATE_FAILURE:
      return combineOnKey('soonestEventDate', state, {
        data: null,
        error: payload,
        status: 'FAILURE',
      })
    case GET_SOONEST_EVENT_DATE_PENDING:
      return combineOnKey('soonestEventDate', state, {
        status: 'PENDING',
      })
    case GET_SOONEST_EVENT_DATE_SUCCESS:
      return combineOnKey('soonestEventDate', state, {
        data: payload,
        error: null,
        status: 'SUCCESS',
      })
    case LOGIN_FAILURE:
      return combineOnKey('login', state, {
        data: null,
        error: payload,
        status: 'FAILURE',
      })
    case LOGIN_PENDING:
      return combineOnKey('login', state, {
        status: 'PENDING',
      })
    case LOGIN_SUCCESS:
      return combineOnKey('login', state, {
        data: payload,
        error: null,
        status: 'SUCCESS',
      })
    case REGISTRATION_FAILURE:
      return combineOnKey('registration', state, {
        data: null,
        error: payload,
        status: 'FAILURE',
      })
    case REGISTRATION_PENDING:
      return combineOnKey('registration', state, {
        status: 'PENDING',
      })
    case REGISTRATION_SUCCESS:
      return combineOnKey('registration', state, {
        data: payload,
        error: null,
        status: 'SUCCESS',
      })
    case PASSWORD_RESET_REQUEST_FAILURE:
      return combineOnKey('passwordReset', state, {
        data: null,
        error: payload,
        status: 'FAILURE',
      })
    case PASSWORD_RESET_REQUEST_PENDING:
      return combineOnKey('passwordReset', state, {
        status: 'PENDING',
      })
    case PASSWORD_RESET_REQUEST_SUCCESS:
      return combineOnKey('passwordReset', state, {
        data: payload,
        error: null,
        status: 'SUCCESS',
      })
    default:
      return null
  }
})
